export const common = {
  // Navigation
  'nav.features': 'Funksjoner',
  'nav.howItWorks': 'Slik fungerer det',
  'nav.pricing': 'Priser',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Om oss',
  'nav.getStarted': 'Kom i gang',

  // About Us Section
  'aboutUs.badge': "Om oss",
  'aboutUs.title': "Hvorfor IdeaVerdict finnes",
  'aboutUs.line1': "Hvem som helst kan ha en idé.",
  'aboutUs.line2': "Få innrømmer at deres ikke holder.",
  'aboutUs.paragraph1':
    "De fleste ideer feiler ikke fordi grunnleggerne manglet mot. De feiler fordi ingen sa sannheten tidlig nok. IdeaVerdict lukker det gapet — vi gir deg den brutale lesningen vennene dine ikke gjør.",
  'aboutUs.belief1a': "Vi handler ikke med hype.",
  'aboutUs.belief1b': "Vi handler med markedssignaler.",
  'aboutUs.belief2a': "Vi selger ikke motivasjon.",
  'aboutUs.belief2b': "Vi selger en tydelig lesning av etterspørsel, konkurranse og gjennomførbarhet.",
  'aboutUs.mission1': "Jobben vår er ikke å få ideen din til å se bra ut.",
  'aboutUs.mission2': "Jobben vår er å si om den er det.",
  'aboutUs.analysis':
    "IdeaVerdict vurderer ideer på det som teller — markedsstruktur, reell etterspørsel, konkurranse, kapitalbehov, tid til inntekt, skalerbarhet. Ingen følelser. Ingen optimisme. Bare analyse.",
  'aboutUs.failure1': "De fleste bedrifter feiler.",
  'aboutUs.failure2': "Ikke fordi menneskene bak dem var inkompetente —",
  'aboutUs.failure3': "men fordi ingen presset tilbake hardt nok, tidlig nok.",
  'aboutUs.clarity': "Vi finnes for å presse tilbake.",
  'aboutUs.value1': "Direkte.",
  'aboutUs.value2': "Ærlig.",
  'aboutUs.value3': "Raskt.",
  'aboutUs.confirm': "Hvis ideen din har substans, støtter vi den.",
  'aboutUs.deny': "Hvis ikke, sier vi det rett i ansiktet ditt.",
  'aboutUs.noApplause': "Ingen applaus.",
  'aboutUs.noSugarcoating': "Ingen sukring.",
  'aboutUs.noTheater': "Intet teater.",
  'aboutUs.noHype': "Bare dommen.",
  // Hero Section
  'hero.badge': 'AI-dom på under 60 sekunder',
  'hero.title1': 'Ikke bygg',
  'hero.title2': 'før du sjekker.',
  'hero.subtitle': 'IdeaVerdict tester ideen din som en skeptisk VC.',
  'hero.subtitleLine2': 'Ærlig dom på sekunder — ingen hype, ingen smiger.',
  'hero.cta': 'Få min dom',
  'hero.ctaSecondary': 'Se hvordan det fungerer',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Studiepoeng per forespørsel',
  'hero.stat2Value': 'Fra 7',
  'hero.stat2Label': 'Vurderingsdimensjoner',
  'hero.stat3Value': '100 %',
  'hero.stat3Label': 'Ærlig og privat',

  // Features Section
  'features.title1': 'Bygget for',
  'features.title2': 'grunnleggere som',
  'features.title3': 'vil ha sannheten',
  'features.bullet1.title': 'Ærlig dom på sekunder',
  'features.bullet1.description':
    'Sterk, Blandet eller Svak — med begrunnelsen bak. Ingen applaus, ingen pynt, ingen teater.',
  'features.bullet2.title': 'Vurdert på det som teller',
  'features.bullet2.description':
    'Ideen din vurderes på reell etterspørsel, konkurranse, kapitalbehov, tid til inntekt og skalerbarhet — ikke følelser.',
  'features.bullet3.title': 'Fra dom til bygging',
  'features.bullet3.description':
    'Builder-modus gjør en godkjent idé om til en utviklerbrief: brukerflyt, kjernefunksjoner, tekniske notater.',

  // How It Works
  'howItWorks.title': 'Slik fungerer det',
  'howItWorks.subtitle': 'Fire trinn til klarhet om forretningsnisjen din.',
  'howItWorks.step1Title': 'Velg en plan',
  'howItWorks.step1Desc': 'Starter, Pro eller Builder – avhengig av dybden på gjennomgangen din.',
  'howItWorks.step2Title': 'Spør AI',
  'howItWorks.step2Desc': 'Still spørsmålene dine om nisjen. Hver forespørsel koster 30 studiepoeng.',
  'howItWorks.step3Title': 'Få ærlig dom',
  'howItWorks.step3Desc': 'AI rangerer: Bra, Gjennomsnittlig eller Dårlig. Ingen sukkerbelegg.',
  'howItWorks.step4Title': 'Ta en beslutning',
  'howItWorks.step4Desc': 'Nå vet du om det er verdt å gå videre.',

  // Pricing
  'pricing.title': 'Priser',
  'pricing.subtitle': 'Velg planen som passer til gjennomgangsdybden din.',
  'pricing.monthly': 'Månedlig',
  'pricing.yearly': 'Årlig',
  'pricing.yearlyDiscount': 'Årlig abonnement:',
  'pricing.yearlyDiscountValue': '-20 % rabatt',
  'pricing.perMonth': 'per måned',
  'pricing.selectPlan': 'Velg plan',
  'pricing.mostPopular': 'Mest populær',
  'pricing.footer':
    'Alle priser i CHF. Studiepoeng trekkes kun for vellykkede AI-svar.',

  
  // Pricing Features
  'pricing.feature1': 'Gratis chat (uten skjema)',
  'pricing.feature2': 'Markedslogikk og ærlig vurdering',
  'pricing.feature3': 'Vedvarende chathistorikk',
  'pricing.feature4': 'Flere parallelle chatøkter',
  'pricing.feature5': 'Fullt flerspråklig',
  'pricing.feature6': 'Kredittbasert bruk',
  'pricing.feature7': 'Månedlig tilbakestilling',
  'pricing.feature8': 'Markedsanalyse',
  'pricing.feature9': 'Sammendrag',
  'pricing.feature10': 'Styrker',
  'pricing.feature11': 'Svakheter',
  'pricing.feature12': 'Muligheter',
  'pricing.feature13': 'Risikoer',
  'pricing.feature14': 'Anbefalinger',
  'pricing.feature15': 'Last ned PDF',
  'pricing.feature16': 'Ingen utviklerbriefinger',
  'pricing.feature17': 'Byggermodus: Utviklerbriefinger',
  'pricing.feature18': 'Strukturert sammendrag',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Tilgang til AI nisje-chatbot',
  'pricing.starter.credits': '2 500 studiepoeng per måned',
  'pricing.starter.feature1': 'Generer nisjeidé',
  'pricing.starter.feature2': 'Foredle nisje',
  'pricing.starter.feature3': 'Markedsrealitetssjekk',
  'pricing.starter.feature4': 'Konkurransevurdering',
  'pricing.starter.feature5': 'Tidsvurdering',
  'pricing.starter.feature6': 'Ærlig dom',
  'pricing.starter.feature7': 'Private økter',
  'pricing.starter.feature8': 'Historikk og eksport',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Tilgang til AI nisje-chatbot',
  'pricing.pro.credits': '5 000 studiepoeng per måned',
  'pricing.pro.feature1': 'Alle Starter-funksjoner',
  'pricing.pro.feature2': 'Flere studiepoeng for intensiv gjennomgang',
  'pricing.pro.feature3': 'Forbedringsforslag',
  'pricing.pro.feature4': 'Alternative nisjer',
  'pricing.pro.feature5': 'Detaljert markedsanalyse',
  'pricing.pro.feature6': 'Prioritert støtte',
  'pricing.pro.feature7': 'Avanserte filtre',
  'pricing.pro.feature8': 'Øktfavoritter',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Alle funksjoner + Builder-modus",
  'pricing.builder.credits': "10 000 credits per måned",
  'pricing.builder.feature1': 'Alle Pro-funksjoner',
  'pricing.builder.feature2': 'Ubegrensede AI-forespørsler',
  'pricing.builder.feature3': 'Builder-modus: Utviklerbriefinger',
  'pricing.builder.feature4': 'Strukturert prosjektoversikt',
  'pricing.builder.feature5': 'Brukerflyter og kjernfunksjoner',
  'pricing.builder.feature6': 'Tekniske notater',
  'pricing.builder.feature7': 'Definer ikke-mål',
  'pricing.builder.feature8': 'Fair use-grense',
  'pricing.builder.limitNote': 'Fair use-grense',
  'pricing.monthlyReset': 'Tilbakestilles månedlig',

  // Modal
  'pricing.modal.selected': 'valgt',
  'pricing.modal.comingSoon':
    'Registrering og betalingsbehandling vil være tilgjengelig snart.',
  'pricing.modal.patience':
    'Vi jobber med å gi deg en sikker og sømløs opplevelse. Vennligst vær tålmodig.',
  'pricing.modal.understood': 'Forstått',

  // FAQ
  'faq.title': 'Ofte stilte spørsmål',
  'faq.subtitle': 'Besvart ærlig og kritisk.',
  'faq.q1': "Hva gjør IdeaVerdict egentlig?",
  'faq.a1': "Den vurderer forretningsideen din på det som avgjør utfall — reell etterspørsel, konkurranse, kapitalbehov, time-to-market og skalerbarhet.\nHvis ideen holder, viser vi hvordan du skjerper den.\nHvis ikke, sier vi det også.",
  'faq.q2': "Genererer dere også ideer?",
  'faq.a2': "Ja — men ingen tilfeldige forslag ut av en hatt.\nIdeer kommer fra reelle markedshull, ikke fra det som trender denne uken.",
  'faq.q3': "Forbedrer dere eksisterende forretningsmodeller?",
  'faq.a3': "Ja, hvis det er noe å forbedre.\nVi polerer ikke ødelagte ideer — vi styrker de som allerede har et fundament.",
  'faq.q4': "Hva skiller dere fra andre AI-verktøy?",
  'faq.a4': "De fleste AI-verktøy sier at ideen din er fantastisk.\nVi sier om den faktisk er det.\nForskjellen: realisme i stedet for entusiasme.",
  'faq.q5': "Garanterer dette suksess?",
  'faq.a5': "Nei.\nVi hjelper deg å unngå dårlige veddemål — risikoen forsvinner ikke, men du går inn med åpne øyne.",
  'faq.q6': "Hvem er IdeaVerdict for?",
  'faq.a6': "Gründere før lansering.\nBuilders før helgens sideprosjekt.\nOperatører før neste veddemål.\nInvestorer før signaturen.\n\nFor alle som vil ha klarhet før forpliktelse.",
  'faq.q7': "Hva om jeg bare vil ha bekreftelse?",
  'faq.a7': "Da er IdeaVerdict feil verktøy.\nVi leverer en ærlig lesning, ikke trøst.",
  'faq.q8': "Hvor ærlig er analysen egentlig?",
  'faq.a8': "Så ærlig som dataene tillater.\nVi mykner ikke en svak dom for å skåne følelser.",
  'faq.q9': "Erstatter dette ekte markedsundersøkelser?",
  'faq.a9': "Nei.\nDet er en rask strategisk sjekk før du investerer — ikke en 50-siders markedsstudie.",
  'faq.q10': "Hvorfor så direkte?",
  'faq.a10': "Fordi å bygge feil ting koster måneder.\nEn ærlig dom koster minutter.\n\nVi velger minuttene.",
  // Footer
  'footer.description':
    'IdeaVerdict er ikke her for å få deg til å føle deg bra. Det er her for å hjelpe deg å bestemme riktig.',
  'footer.product': 'Produkt',
  'footer.aiAssistant': 'AI-assistent',
  'footer.howItWorks': 'Slik fungerer det',
  'footer.pricing': 'Priser',
  'footer.faq': 'Ofte stilte spørsmål',
  'footer.legal': 'Juridisk',
  'footer.privacy': 'Personvern',
  'footer.terms': 'Vilkår',
  'footer.imprint': 'Impressum',
  'footer.support': 'Støtte',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentasjon',
  'footer.copyright': '© 2026 IdeaVerdict. Alle rettigheter forbeholdt.',

  // AI Assistant
  'aiAssistant.title': 'AI Nisjeassistent',
  'aiAssistant.subtitle': 'Spør om nisjer',
  'aiAssistant.welcomeMessage':
    'Hei! Beskriv idéen din eller spør meg om en nisje. Jeg vil gi deg en klar og ærlig evaluering.',
  'aiAssistant.demoResponse':
    'Dette er en demo. For å få ekte AI-evalueringer, vennligst registrer deg og velg en plan.',
  'aiAssistant.placeholder': 'Beskriv idéen din...',

  // Header & Sidebar
  'dashboard.header.title': 'Dashboard',
  'dashboard.header.aiAssistant': 'Din AI-assistent',
  'header.logout': 'Logg ut',
  'dashboard.sidebar.overview': 'Oversikt',
  'dashboard.sidebar.aiChat': 'AI-assistent',
  'dashboard.sidebar.newAnalysis': 'AI-assistent',
  'dashboard.sidebar.history': 'Historikk',
  'dashboard.sidebar.credits': 'Studiepoeng',
  'dashboard.sidebar.settings': 'Innstillinger',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Velkommen tilbake, {{name}}',
  'dashboard.overview.subtitle':
    'Her er en rask oversikt over aktiviteten din',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Gjenværende studiepoeng',
  'dashboard.stats.totalAnalyses': 'Totalt analyser',
  'dashboard.stats.goodRatings': 'Positive vurderinger',
  'dashboard.stats.nextReset': 'Neste tilbakestilling om',
  'dashboard.stats.days': 'dager',

  // Quick Actions
  'dashboard.quickActions.title': 'Hurtighandlinger',
  'dashboard.quickActions.checkNewIdea': 'Sjekk en idé',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Analyser en eksisterende forretningsidé',
  'dashboard.quickActions.generateIdea': 'Generer en idé',
  'dashboard.quickActions.generateIdeaDesc':
    'Finn en ny lønnsom nisje',
  'dashboard.quickActions.builderBriefing': 'Byggherrebriefing',
  'dashboard.quickActions.builderBriefingDesc':
    'Gjør om en idé til en utviklerklar briefing',
  'dashboard.quickActions.premiumOnly': 'Kun byggherre',

  // Chat Header
  'chat.title': 'AI Nisjeassistent',
  'chat.subtitle':
    'Still spørsmål om nisjer. Jeg evaluerer kritisk og ærlig.',
  'chat.creditsLabel': 'Studiepoeng',

  // Chat Welcome
  'chat.welcomeTitle': 'Velkommen til AI Nisjeassistenten',
  'chat.welcomeDesc':
    'Beskriv idéen din eller spør om en nisje. Jeg vil evaluere den ærlig: Bra, Gjennomsnittlig eller Dårlig.',
  'chat.aiWelcome':
    'Hei! Beskriv idéen din eller spør meg om en nisje. Jeg vil gi deg en klar og ærlig evaluering.',

  // Chat Suggestions
  'chat.suggestion1': 'Jeg vil bygge et SaaS-verktøy for frilansere til å håndtere fakturaer. Er dette en god nisje?',
  'chat.suggestion2': 'Finn meg en nettbusiness med lav konkurranse som jeg kan starte med $500 uten programmeringskunnskap.',
  'chat.suggestion3': 'Vurder dette: en AI-drevet måltidsplanleggingsapp for travle foreldre med kostholdsbegrensninger.',
  'chat.suggestion4': 'Jeg vil selge digitale maler på Etsy for småbedriftseiere. Analyser denne nisjen ærlig.',

  // Chat Actions
  'chat.newConversation': 'Ny samtale',
  'chat.today': 'I dag',
  'chat.yesterday': 'I går',
  'chat.thisWeek': 'Denne uken',
  'chat.thisMonth': 'Denne måneden',
  'chat.older': 'Eldre',
  'chat.messages': 'meldinger',
  'chat.renameConversation': 'Gi nytt navn',
  'chat.deleteConversation': 'Slett',
  'chat.cancel': 'Avbryt',
  'chat.rename': 'Gi nytt navn',
  'chat.delete': 'Slett',
  'chat.favorite': 'Legg til favoritt',
  'chat.unfavorite': 'Fjern favoritt',
  'chat.searchSessions': 'Søk i samtaler...',
  'chat.noResults': 'Ingen resultater funnet',
  'chat.noSessions': 'Ingen samtaler ennå',
  'chat.enterNewName': 'Skriv inn nytt navn...',
  'chat.deleteConfirmMessage':
    'Er du sikker på at du vil slette denne samtalen? Denne handlingen kan ikke angres.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Skriv spørsmålet ditt… (koster 30 studiepoeng)',
  'chat.send': 'Send',
  'chat.voice': 'Tal',
  'chat.listeningPlaceholder': 'Jeg lytter... Snakk nå.',
  'chat.stopListening': 'Slutt å lytte',
  'chat.recording': 'Opptak...',
  'chat.speechNotSupported': 'Nettleseren din støtter ikke talegjenkjenning.',
  'chat.microphonePermissionDenied': 'Tilgang til mikrofon nektet. Vennligst tillat tilgang i nettleserinnstillingene.',
  'chat.errorNotEnoughCredits':
    'Ikke nok studiepoeng. Vennligst oppgrader planen din eller vent på neste tilbakestilling.',
  'chat.errorAiFailed': 'AI-svaret mislyktes. Ingen studiepoeng ble trukket.',
  'chat.errorRateLimit': 'For mange forespørsler. Vennligst vent et øyeblikk.',

  // Ratings
  'rating.good': 'Bra',
  'rating.medium': 'Gjennomsnittlig',
  'rating.bad': 'Dårlig',

  // Auth Page
  'auth.branding.headline1': 'Ikke alle idéer er gode.',
  'auth.branding.headline2': 'Vi forteller deg ærlig.',
  'auth.branding.subtitle':
    'En beslutnings-AI for forretningsnisjer. Tydelig. Kritisk. Ingen sukkerbelegg.',
  'auth.benefits.privacy.title': '100 % privat',
  'auth.benefits.privacy.desc':
    'Idéene dine forblir helt private og sikre.',
  'auth.benefits.honest.title': 'Ærlig AI',
  'auth.benefits.honest.desc':
    'Ingen sukkerbelegg – bare klar, kritisk tilbakemelding.',
  'auth.benefits.fast.title': 'Raske resultater',
  'auth.benefits.fast.desc': 'Få klarhet om nisjen din på minutter.',
  'auth.trust.users': 'Aktive brukere',
  'auth.trust.ideas': 'Idéer analysert',
  'auth.trust.rating': 'Brukervurdering',
  'auth.login.title': 'Innlogging',
  'auth.login.headline': 'Velkommen tilbake',
  'auth.login.subtitle': 'Logg inn for å fortsette reisen din.',
  'auth.login.forgotPassword': 'Glemt passord?',
  'auth.login.submit': 'Logg inn',
  'auth.login.noAccount': 'Har du ingen konto ennå?',
  'auth.login.signUp': 'Registrer deg',
  'auth.register.title': 'Registrer deg',
  'auth.register.headline': 'Opprett kontoen din',
  'auth.register.subtitle':
    'Begynn å analysere forretningsidéene dine i dag.',
  'auth.register.submit': 'Opprett konto',
  'auth.register.hasAccount': 'Har du allereden en konto?',
  'auth.register.signIn': 'Logg inn',
  'auth.fields.name': 'Fullt navn',
  'auth.fields.email': 'E-postadresse',
  'auth.fields.password': 'Passord',
  'auth.fields.confirmPassword': 'Bekreft passord',
  'auth.fields.selectPlan': 'Velg planen din',
  'auth.fields.testCode': 'Logg inn og test gratis',
  'auth.placeholders.name': 'Skriv inn navnet ditt',
  'auth.placeholders.email': 'Skriv inn e-posten din',
  'auth.placeholders.password': 'Skriv inn passordet ditt',
  'auth.placeholders.confirmPassword': 'Bekreft passordet ditt',
  'auth.placeholders.testCode': 'Skriv inn testkode',
  'auth.terms.accept': 'Jeg godtar',
  'auth.terms.terms': 'Vilkår og betingelser',
  'auth.privacy.accept': 'Jeg godtar',
  'auth.privacy.policy': 'Personvernerklæringen',
  'auth.errors.nameRequired': 'Navn er påkrevd',
  'auth.errors.emailRequired': 'E-post er påkrevd',
  'auth.errors.emailInvalid': 'Vennligst skriv inn en gyldig e-post',
  'auth.errors.passwordRequired': 'Passord er påkrevd',
  'auth.errors.passwordLength': 'Passordet må være minst 8 tegn',
  'auth.errors.passwordMismatch': 'Passordene samsvarer ikke',
  'auth.errors.invalidCode': 'Ugyldig eller utløpt kode',
  'auth.errors.registrationCodeOnly': 'Denne koden er kun for registrering',
  'auth.errors.verificationFailed': 'Feil ved bekreftelse av kode. Vennligst prøv igjen.',
  'auth.loading': 'Vennligst vent...',
  'auth.or': 'eller fortsett med',
  'auth.social.google': 'Fortsett med Google',
  'auth.social.apple': 'Fortsett med Apple',
  'auth.actions.verify': 'Bekreft',
  'auth.testCode.activated': 'Testkode aktivert!',
  'auth.testCode.days': 'dager',
  'auth.testCode.months': 'måneder',
  'auth.testCode.freeAccess': 'gratis tilgang',
  'auth.testCode.credits': 'studiepoeng',

  // Email Verification
  'auth.verification.title': 'Bekreft e-post',
  'auth.verification.headline': 'Sjekk innboksen din',
  'auth.verification.subtitle': 'Vi sendte en bekreftelseskode til:',
  'auth.verification.codeLabel': 'Bekreftelseskode',
  'auth.verification.codePlaceholder': 'Skriv inn 6-sifret kode',
  'auth.verification.submit': 'Bekreft e-post',
  'auth.verification.resend': 'Send kode på nytt',
  'auth.verification.resendIn': 'Send på nytt om',
  'auth.verification.seconds': 'sekunder',
  'auth.verification.success': 'E-post bekreftet!',
  'auth.verification.error': 'Ugyldig kode. Vennligst prøv igjen.',
  'auth.verification.expired': 'Koden er utløpt. Vennligst be om en ny.',
  'auth.verification.sent': 'Ny kode sendt!',
  'auth.verification.checkSpam':
    'Mottok du den ikke? Sjekk søppelpostmappen din.',

  // Forgot Password
  'auth.forgot.title': 'Glemt passord',
  'auth.forgot.headline': 'Tilbakestill passordet ditt',
  'auth.forgot.subtitle':
    'Skriv inn e-postadressen din, så sender vi deg en tilbakestillingslenke.',
  'auth.forgot.submit': 'Send tilbakestillingslenke',
  'auth.forgot.backToLogin': 'Tilbake til innlogging',
  'auth.forgot.success': 'E-post sendt!',
  'auth.forgot.successMessage':
    'Vi har sendt deg en e-post med instruksjoner for å tilbakestille passordet ditt.',
  'auth.forgot.checkInbox': 'Sjekk innboksen din',

  // Reset Password
  'auth.reset.title': 'Nytt passord',
  'auth.reset.headline': 'Angi nytt passord',
  'auth.reset.subtitle': 'Skriv inn ditt nye passord.',
  'auth.reset.newPassword': 'Nytt passord',
  'auth.reset.confirmNewPassword': 'Bekreft nytt passord',
  'auth.reset.submit': 'Endre passord',
  'auth.reset.success': 'Passordet er endret!',
  'auth.reset.successMessage':
    'Du kan nå logge inn med ditt nye passord.',
  'auth.reset.loginNow': 'Logg inn nå',

  // Legal Pages
  'legal.backToAuth': 'Tilbake til innlogging',
  'legal.allRightsReserved': 'Alle rettigheter forbeholdt.',

  // Terms Page
  'legal.terms.title': 'Vilkår og betingelser',
  'legal.terms.lastUpdated': 'Sist oppdatert',
  'legal.terms.section1.title': '1. Omfang',
  'legal.terms.section1.content':
    'Disse vilkårene og betingelsene gjelder for alle avtaler mellom NicheFinder (heretter "Tilbyder") og brukeren (heretter "Kunde") angående bruk av AI-drevet nisjeanalyseplattform.',
  'legal.terms.section2.title': '2. Tjenestebeskrivelse',
  'legal.terms.section2.content':
    'Tilbyder tilbyr en AI-basert plattform som analyserer og evaluerer forretningsidéer og nisjer. Tjenestene inkluderer:',
  'legal.terms.section2.item1': 'AI-drevet analyse av forretningsidéer',
  'legal.terms.section2.item2': 'Evaluering av markedspotensial og konkurranse',
  'legal.terms.section2.item3': 'Generering av nisjeforslag',
  'legal.terms.section2.item4': 'Opprettelse av utviklerbriefinger (Builder-pakke)',
  'legal.terms.section3.title': '3. Kontraktsinngåelse og registrering',
  'legal.terms.section3.content':
    'Avtalen inngås ved registrering på plattformen og valg av pakke. Kunden bekrefter:',
  'legal.terms.section3.item1': 'Å være myndig og ha full rettslig handleevne',
  'legal.terms.section3.item2': 'Å oppgi korrekt informasjon ved registrering',
  'legal.terms.section3.item3': 'Sikker lagring av tilgangslegitimasjon',
  'legal.terms.section4.title': '4. Studiepoeng og fakturering',
  'legal.terms.section4.content':
    'Bruk av AI-funksjoner er basert på et studiepoengsystem. Hver AI-forespørsel koster 30 studiepoeng. Studiepoeng trekkes kun ved vellykket svar. Ubrukte studiepoeng utløper ved slutten av faktureringsperioden og refunderes ikke.',
  'legal.terms.section5.title': '5. Ansvarsfraskrivelse',
  'legal.terms.section5.content':
    'AI-evalueringer tjener kun som beslutningsstøtte og garanterer ikke forretningssuksess. Tilbyder er ikke ansvarlig for beslutninger tatt basert på AI-analyser. Ansvaret for forsett og grov uaktsomhet forblir upåvirket.',
  'legal.terms.section6.title': '6. Databeskyttelse og konfidensialitet',
  'legal.terms.section6.content':
    'Alle innsendte forretningsidéer behandles konfidensielt og deles ikke med tredjeparter. Behandling av personopplysninger skjer i samsvar med vår personvernerklæring og gjeldende databeskyttelseslover.',
  'legal.terms.section7.title': '7. Oppsigelse',
  'legal.terms.section7.content':
    'Kunden kan når som helst si opp abonnementet sitt ved slutten av gjeldende faktureringsperiode. Ved brudd på disse vilkårene forbeholder Tilbyder seg retten til å blokkere tilgang til plattformen.',
  'legal.terms.section8.title': '8. Sluttbestemmelser',
  'legal.terms.section8.content':
    'Sveitsisk lov gjelder. Verneting er Zürich, Sveits. Skulle enkelte bestemmelser i disse vilkårene være ugyldige, påvirker ikke dette gyldigheten av de gjenværende bestemmelsene.',
  'legal.terms.contact.title': 'Spørsmål om vilkårene?',
  'legal.terms.contact.content':
    'Hvis du har spørsmål om disse vilkårene og betingelsene, vennligst kontakt oss på:',

  // Privacy Page
  'legal.privacy.title': 'Personvernerklæring',
  'legal.privacy.section1.title': '1. Databehandlingsansvarlig',
  'legal.privacy.section1.content':
    'Databehandlingsansvarlig for dette nettstedet er NicheFinder, Zürich, Sveits. Vi tar beskyttelsen av dine personopplysninger på alvor og behandler dine personopplysninger konfidensielt og i samsvar med lovbestemte databeskyttelsesforskrifter.',
  'legal.privacy.section2.title': '2. Innsamlede data',
  'legal.privacy.section2.content':
    'Vi samler inn og behandler følgende personopplysninger:',
  'legal.privacy.section2.item1':
    'Registreringsdata: Navn, e-postadresse, passord (kryptert)',
  'legal.privacy.section2.item2':
    'Bruksdata: IP-adresse, nettlesertype, tilgangstider',
  'legal.privacy.section2.item3':
    'Forretningsidéer og nisjeforespørsler (lagret anonymt)',
  'legal.privacy.section2.item4':
    'Betalingsinformasjon (via sikre tredjepartsleverandører)',
  'legal.privacy.section3.title': '3. Formål med databehandling',
  'legal.privacy.section3.content':
    'Dine data brukes til følgende formål:',
  'legal.privacy.section3.item1':
    'Tilbud og forbedring av våre AI-tjenester',
  'legal.privacy.section3.item2':
    'Kontoadministrasjon og autentisering',
  'legal.privacy.section3.item3':
    'Fakturering og betalingsbehandling',
  'legal.privacy.section4.title': '4. Datasikkerhet',
  'legal.privacy.section4.content':
    'Vi implementerer tekniske og organisatoriske sikkerhetstiltak for å beskytte dataene dine mot manipulasjon, tap, ødeleggelse eller uautorisert tilgang. Alle dataoverføringer er kryptert via SSL/TLS.',
  'legal.privacy.section5.title': '5. Konfidensialitet av dine forretningsidéer',
  'legal.privacy.section5.content':
    'Dine innsendte forretningsidéer og nisjeforespørsler behandles strengt konfidensielt. De deles ikke med tredjeparter, brukes ikke til treningsformål, og kan slettes fullstendig på forespørsel. Dine idéer tilhører deg.',
  'legal.privacy.section6.title': '6. Dine rettigheter',
  'legal.privacy.section6.content':
    'Du har følgende rettigheter angående dine personopplysninger:',
  'legal.privacy.section6.item1': 'Rett til innsyn i lagrede data',
  'legal.privacy.section6.item2': 'Rett til retting av unøyaktige data',
  'legal.privacy.section6.item3': 'Rett til sletting av dine data',
  'legal.privacy.section6.item4': 'Rett til dataportabilitet',
  'legal.privacy.section7.title': '7. Informasjonskapsler',
  'legal.privacy.section7.content':
    'Nettstedet vårt bruker kun teknisk nødvendige informasjonskapsler for autentisering og øktadministrasjon. Vi bruker ikke sporingskapsler eller analyseverktøy fra tredjeparter uten ditt uttrykkelige samtykke.',
  'legal.privacy.section8.title': '8. Endringer i denne personvernerklæringen',
  'legal.privacy.section8.content':
    'Vi forbeholder oss retten til å tilpasse denne personvernerklæringen for å overholde endrede juridiske krav eller ved endringer i tjenesten. Gjeldende versjon finner du alltid på denne siden.',
  'legal.privacy.contact.title': 'Spørsmål om personvern?',
  'legal.privacy.contact.content':
    'Hvis du har spørsmål om behandlingen av dine personopplysninger, vennligst kontakt oss på:',

  'auth.passwordStrength.label': 'Passordstyrke',
  'auth.passwordStrength.weak': 'Svakt',
  'auth.passwordStrength.medium': 'Middels',
  'auth.passwordStrength.strong': 'Sterkt',
  'auth.passwordStrength.veryStrong': 'Veldig sterkt',
  'auth.passwordStrength.minLength': 'Min. 8 tegn',
  'auth.passwordStrength.uppercase': 'Stor bokstav',
  'auth.passwordStrength.number': 'Tall',
  'auth.passwordStrength.special': 'Spesialtegn',

  trial: {
    subtitle: 'Gratis prøveversjon',
    upgrade: 'Oppgrader nå',
    creditsRemaining: 'gjenværende studiepoeng',
    inputHint: 'Prøveversjon - Ingen samtalehistorikk tilgjengelig',
    banner: {
      title: '7-dagers prøveversjon aktiv',
      remaining: '{{days}} dager igjen',
      credits: 'studiepoeng tilgjengelig',
      upgradeNow: 'Oppgrader nå',
    },
    welcome: {
      title: 'Velkommen til gratis prøveversjonen!',
      desc: 'Test vår AI-assistent gratis i 7 dager med 100 studiepoeng. Still spørsmål og oppdag mulighetene!',
    },
    info: {
      title: 'Begrensninger i prøveversjonen',
      credits: '100 studiepoeng i 7 dager',
      noHistory: 'Ingen samtalehistorikk',
      noSettings: 'Begrensede funksjoner',
      upgrade: 'Oppgrader for alle funksjoner',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Innstillinger',
  'settings.subtitle': 'Administrer kontoen din og preferanser',
  'settings.backToOverview': 'Tilbake til oversikt',
  'settings.subscriptionLink': 'Abonnement og fakturering',
  'settings.saved': 'Endringer lagret',
  'settings.changesSaved': 'Endringer lagret',
  'settings.saveChanges': 'Lagre endringer',
  'settings.dataExported': 'Data eksportert',

  // Tabs
  'settings.tabs.profile': 'Profil',
  'settings.tabs.preferences': 'Preferanser',
  'settings.tabs.notifications': 'Varsler',
  'settings.tabs.account': 'Konto og plan',

  // Profile
  'settings.profile.changePhoto': 'Bytt bilde',
  'settings.profile.photoHint': 'JPG, PNG eller GIF (maks. 2 MB)',
  'settings.profile.uploading': 'Laster opp...',
  'settings.profile.photoUpdated': 'Profilbilde oppdatert!',
  'settings.profile.name': 'Navn',
  'settings.profile.email': 'E-post',
  'settings.profile.phone': 'Telefon',
  'settings.profile.changePassword': 'Endre passord',
  'settings.profile.currentPassword': 'Nåværende passord',
  'settings.profile.newPassword': 'Nytt passord',
  'settings.profile.confirmPassword': 'Bekreft passord',

  // Preferences
  'settings.preferences.language': 'Språk',
  'settings.preferences.chooseLanguage': 'Velg språk',
  'settings.preferences.timezone': 'Tidssone',
  'settings.preferences.currency': 'Valuta',

  // Notifications
  'settings.notifications.emailTitle': 'E-postvarsler',
  'settings.notifications.email.analysis': 'Analyse fullført',
  'settings.notifications.email.analysisDesc': 'Motta e-post når analysen din er klar',
  'settings.notifications.email.credits': 'Oppdateringer om studiepoeng',
  'settings.notifications.email.creditsDesc': 'Varsler om studiepoeng og tilbakestillinger',
  'settings.notifications.email.billing': 'Fakturaer og betalinger',
  'settings.notifications.email.billingDesc': 'Varsler om fakturaer og planendringer',
  'settings.notifications.email.newsletter': 'Nyhetsbrev',
  'settings.notifications.email.newsletterDesc': 'Tips, oppdateringer og nye funksjoner',
  'settings.notifications.pushTitle': 'Push-varsler',
  'settings.notifications.push.analysis': 'Analyse fullført',
  'settings.notifications.push.analysisDesc': 'Nettleservarsel når analyse er klar',
  'settings.notifications.push.credits': 'Advarsler om studiepoeng',
  'settings.notifications.push.creditsDesc': 'Advarsel når studiepoengsaldoen er lav',

  // Account
  'settings.account.currentSubscription': 'Nåværende abonnement',
  'settings.account.plan': 'Plan',
  'settings.account.price': 'Pris',
  'settings.account.nextBilling': 'Neste fakturering',
  'settings.account.manageSubscription': 'Administrer abonnement og betalinger',
  'settings.account.dataPrivacy': 'Data og personvern',
  'settings.account.exportData': 'Eksporter data',
  'settings.account.deleteAccount': 'Slett konto',

  // Delete Modal
  'settings.deleteModal.title': 'Slett konto?',
  'settings.deleteModal.subtitle': 'Alle data vil bli slettet permanent.',
  'settings.deleteModal.warning1': 'Alle analyser og data vil bli slettet',
  'settings.deleteModal.warning2': 'Aktivt abonnement kanselleres umiddelbart',
  'settings.deleteModal.warning3': 'Ingen refusjon mulig',
  'settings.deleteModal.confirmLabel': 'Skriv "{{word}}" for å bekrefte *',
  'settings.deleteModal.cancel': 'Avbryt',
  'settings.deleteModal.confirm': 'Slett konto',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'Tilbake til oversikt',
  'sub.settings': 'Innstillinger',
  'sub.title': 'Abonnement og fakturering',
  'sub.subtitle': 'Administrer abonnement, betalingsmåter og fakturaer',
  'sub.tab.overview': 'Oversikt',
  'sub.tab.payment': 'Betalingsmåter',
  'sub.tab.billing': 'Fakturaadresse',
  'sub.tab.history': 'Betalingshistorikk',
  'sub.memberSince': 'Medlem siden',
  'sub.perMonth': 'per måned',
  'sub.baseCHF': '(CHF {{amount}} basis)',
  'sub.nextBilling': 'Neste fakturering',
  'sub.creditsUsed': 'Studiepoeng brukt',
  'sub.paymentMethod': 'Betalingsmåte',
  'sub.creditUsage': 'Studiepoengbruk',
  'sub.changePlan': 'Endre plan',
  'sub.reactivate': 'Reaktiver',
  'sub.cancelSub': 'Kanseller abonnement',
  'sub.manageCards': 'Administrer kort',
  'sub.downloadInvoices': 'Last ned fakturaer',
  'sub.invoicesAvailable': '{{count}} fakturaer tilgjengelig som PDF',
  'sub.accountSettings': 'Kontoinnstillinger',
  'sub.profileNotifications': 'Profil, varsler og mer',
  // Prices in EUR info
  'sub.eurInfo': 'Priser vist i',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Kurs:',
  'sub.currentRate': 'Gjeldende kurs',
  // Payment Methods
  'sub.savedCards': 'Lagrede kort',
  'sub.newCard': 'Nytt kort',
  'sub.default': 'Standard',
  'sub.setDefault': 'Angi som standard',
  'sub.validUntil': 'Gyldig til',
  'sub.noCards': 'Ingen kort lagret',
  'sub.addFirstCard': 'Legg til første kort',
  'sub.securePayments': 'Sikre betalinger',
  'sub.securePaymentsDesc': 'Alle betalingsdata overføres kryptert og lagres sikkert hos vår betalingsleverandør. Vi lagrer ikke fullstendige kortnumre.',
  // Billing Address
  'sub.billingAddress': 'Fakturaadresse',
  'sub.edit': 'Rediger',
  'sub.name': 'Navn',
  'sub.streetAddress': 'Gate og nummer',
  'sub.zip': 'Postnummer',
  'sub.city': 'Sted',
  'sub.country': 'Land',
  'sub.address': 'Adresse',
  'sub.save': 'Lagre',
  'sub.cancel': 'Avbryt',
  'sub.country.switzerland': 'Sveits',
  'sub.country.germany': 'Tyskland',
  'sub.country.austria': 'Østerrike',
  'sub.country.netherlands': 'Nederland',
  'sub.country.belgium': 'Belgia',
  // Payment History
  'sub.paymentHistory': 'Betalingshistorikk',
  'sub.allInvoicesPDF': 'Last ned alle fakturaer som PDF med logo',
  'sub.downloadAll': 'Last ned alle',
  'sub.eurInvoiceNote': 'Fakturaer utstedes alltid i CHF. Viste EUR-beløp er kun veiledende.',
  'sub.date': 'Dato',
  'sub.description': 'Beskrivelse',
  'sub.net': 'Netto',
  'sub.vat': 'MVA',
  'sub.total': 'Totalt',
  'sub.status': 'Status',
  'sub.pdf': 'PDF',
  'sub.invoices': 'fakturaer',
  'sub.totalAmount': 'Totalt beløp',
  // Change Plan Modal
  'sub.changePlanTitle': 'Endre plan',
  'sub.current': 'Nåværende',
  'sub.month': '/måned',
  'sub.showLess': 'Vis mindre',
  'sub.showMore': '+{{count}} flere',
  'sub.switchPlan': 'Bytt plan',
  'sub.eurPriceNote': 'Priser vist i EUR ({{note}}). Fakturering skjer i CHF.',
  // Cancel Modal
  'sub.cancelTitle': 'Vil du virkelig kansellere abonnementet?',
  'sub.cancelIrreversible': 'Denne handlingen kan ikke angres.',
  'sub.cancelWarning1': 'Alle gjenværende studiepoeng vil utløpe',
  'sub.cancelWarning2': 'Nedgradering til gratisplan',
  'sub.cancelWarning3': 'Tap av alle premiumfunksjoner',
  'sub.pauseInstead': 'Alternativt: Sett abonnement på pause?',
  'sub.pauseDesc': 'Sett abonnementet på pause i stedet og behold dataene dine.',
  'sub.preferPause': 'Foretrekker å sette på pause',
  'sub.cancelReason': 'Kanselleringsgrunn',
  'sub.selectReason': 'Vennligst velg...',
  'sub.reason.tooExpensive': 'For dyrt',
  'sub.reason.notUsing': 'Bruker det ikke nok',
  'sub.reason.missingFeatures': 'Mangler funksjoner',
  'sub.reason.foundAlternative': 'Fant et alternativ',
  'sub.reason.other': 'Annet',
  'sub.confirmType': 'Bekreftelse: Skriv "CANCEL" *',
  'sub.cancelNow': 'Kanseller nå',
  // Add Card Modal
  'sub.addCardTitle': 'Legg til nytt kort',
  'sub.cardHolder': 'Kortholder *',
  'sub.cardNumber': 'Kortnummer *',
  'sub.expiryDate': 'Utløpsdato *',
  'sub.addCard': 'Legg til kort',
  // Change Card Modal
  'sub.choosePayment': 'Velg betalingsmåte',
  'sub.active': 'Aktiv',
  'sub.close': 'Lukk',
  // Toast messages
  'sub.toast.cancelled': 'Abonnementet ditt er kansellert ved slutten av faktureringsperioden.',
  'sub.toast.reactivated': 'Abonnementet ditt er vellykket reaktivert!',
  'sub.toast.planChanged': 'Planen er vellykket endret til {{plan}}!',
  'sub.toast.defaultChanged': 'Standard betalingsmåte endret.',
  'sub.toast.cannotDeleteDefault': 'Standardkortet kan ikke slettes.',
  'sub.toast.cardRemoved': 'Kortet er fjernet.',
  'sub.toast.fillAll': 'Vennligst fyll ut alle feltene.',
  'sub.toast.cardAdded': 'Nytt kort er lagt til!',
  'sub.toast.billingSaved': 'Fakturaadresse lagret.',
  'sub.toast.invoiceDownloaded': 'Faktura {{id}} lastet ned!',
  'sub.toast.pdfError': 'Feil ved opprettelse av PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'Ikke nok studiepoeng',
  'sub.needCredits': 'Du trenger minst {{count}} studiepoeng per spørsmål.',
  'sub.creditsLow': 'Lite studiepoeng igjen',
  'sub.questionsLeft': '{{count}} spørsmål mulig.',
  'sub.plan': 'Plan',
  'sub.base': 'basis',
  'sub.unlimited': 'Ubegrenset',
  'sub.status.active': 'Aktiv',
  'sub.status.cancelled': 'Kansellert',
  'sub.status.paused': 'Satt på pause',
  'sub.invoice': 'FAKTURA',
  'sub.from': 'FRA',
  'sub.to': 'TIL',
  'sub.vatId': 'MVA-nummer',
  'sub.tel': 'Tlf',
  'sub.invoiceDate': 'Fakturadato',
  'sub.invoiceNumber': 'Fakturanummer',
  'sub.paymentStatus': 'Betalingsstatus',
  'sub.creditCard': 'Kredittkort',
  'sub.quantity': 'ANT',
  'sub.price': 'PRIS',
  'sub.amount': 'BELØP',
  'sub.subtotal': 'Delsum',
  'sub.bank': 'Bank',
  'sub.card': 'Kort',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'Ola Nordmann',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Admin-dashboard',
  'admin.subtitle': 'Kontrollsenter',
  'admin.superAdmin': 'Superadmin',
  'admin.logout': 'Logg ut',
  'admin.tabs.users': 'Brukeradministrasjon',
  'admin.tabs.downgrades': 'Nedgraderinger',
  'admin.tabs.tips': 'Dagens tips',
  'admin.tabs.coupons': 'Rabattkoder',
  'admin.tabs.website': 'Nettstedredigering',
  'admin.tabs.ai': 'AI-innstillinger',
  'admin.tabs.transactions': 'Transaksjonslogg',
  'admin.tabs.stats': 'Statistikk',
  'admin.users.searchPlaceholder': 'Søk etter brukere (e-post eller navn)...',
  'admin.users.manageSubscription': 'Administrer abonnement',
  'admin.users.grantFree': 'Gi gratis konto',
  'admin.users.blockUser': 'Blokker bruker',
  'admin.users.cancellationPlaceholder': 'Hvorfor kanselleres abonnementet?',
  'admin.users.selectPlan': 'Velg plan',
  'admin.users.subChanged': 'Abonnementet til {{name}} endret til {{plan}}',
  'admin.users.noReasonGiven': 'Ingen grunn oppgitt',
  'admin.users.subCancelled': 'Abonnementet til {{name}} kansellert (gyldig til {{date}})',
  'admin.users.paused': 'Satt på pause',
  'admin.users.subPaused': 'Abonnementet til {{name}} er satt på pause',
  'admin.users.subReactivated': 'Abonnementet til {{name}} er reaktivert',
  'admin.users.freeAccount': 'Gratis konto',
  'admin.users.blocked': 'Blokkert',
  'admin.users.cancelledExpiring': 'Kansellert (utløper)',
  'admin.users.cancelledOn': 'Kansellert:',
  'admin.users.endsOn': 'Slutter:',
  'admin.users.daysRemaining': 'dager igjen',
  'admin.users.expired': '(Utløpt)',
  'admin.users.total': 'Totalt:',
  'admin.users.usersLabel': 'brukere',
  'admin.users.free': 'gratis',
  'admin.users.block': 'Blokker',
  'admin.users.unblock': 'Opphev blokkering',
  'admin.users.unblockUser': 'Opphev blokkering av bruker',
  'admin.users.selectAction': 'Velg handling',
  'admin.users.cancelSub': 'Kanseller abonnement',
  'admin.users.cancelSubDesc': 'Kansellering ved månedsslutt',
  'admin.users.pauseSub': 'Sett abonnement på pause',
  'admin.users.pauseSubDesc': 'Midlertidig pause',
  'admin.users.changePlan': 'Endre plan',
  'admin.users.changePlanDesc': 'Bytt til en annen plan',
  'admin.users.reactivateSub': 'Reaktiver abonnement',
  'admin.users.reactivateDesc': 'Angre kansellering',
  'admin.users.alreadyCancelled': 'Abonnementet er allerede kansellert',
  'admin.users.planLabel': 'Plan',
  'admin.users.cancellationReasonOpt': 'Kanselleringsgrunn (valgfritt)',
  'admin.users.cancelInfo1': 'Abonnementet avsluttes',
  'admin.users.cancelInfo2': '(ved månedsslutt). Brukeren har full tilgang frem til da. Ingen refusjon.',
  'admin.users.newPlan': 'Ny plan',
  'admin.users.warning': 'Advarsel',
  'admin.users.blockDesc': 'Brukeren vil umiddelbart bli logget ut og kan ikke logge inn igjen. Alle aktive økter avsluttes.',
  'admin.users.confirmUnblock': 'Bekreft oppheving av blokkering',
  'admin.users.unblockDesc': 'Brukeren kan logge inn igjen og bruke alle funksjoner.',
  'admin.users.afterBlock': 'Etter blokkering:',
  'admin.users.afterUnblock': 'Etter oppheving av blokkering:',
  'admin.users.noAccountAccess': 'Ingen kontotilgang',
  'admin.users.noNewAnalyses': 'Ingen nye analyser mulig',
  'admin.users.creditsStored': 'Studiepoeng og historikk beholdes',
  'admin.users.accessRestored': 'Kontotilgang gjenopprettet',
  'admin.users.allFeaturesAvail': 'Alle funksjoner tilgjengelige igjen',
  'admin.users.creditsPreserved': 'Studiepoeng og historikk beholdes',
  'admin.users.downgrade': 'Nedgrader plan',
  'admin.users.grantFreeBtn': 'Gi gratis',
  'admin.users.durationMonths': 'Varighet (måneder)',
  'admin.users.months': 'måned(er)',
  'admin.users.freePlan': 'gratis',
  'admin.users.freeSummary': 'mottar',
  'admin.users.withCredits': 'med',
  'admin.users.credits': 'Studiepoeng',
  'admin.users.subInfo': 'Abonnementsinformasjon',
  'admin.users.currentPlan': 'Nåværende plan',
  'admin.users.joined': 'Registrert',
  'admin.users.totalSpent': 'Totalt brukt',
  'admin.users.paymentMethod': 'Betalingsmåte',
  'admin.users.validThrough': 'Gyldig til',
  'admin.users.billingAddress': 'Fakturaadresse',
  'admin.users.transactionHistory': 'Transaksjonshistorikk',
  'admin.users.cancellationDate': 'Kanselleringsdato',
  'admin.users.validUntil': 'Gyldig til (månedsslutt)',
  'admin.users.cancellationReason': 'Kanselleringsgrunn',
  'admin.users.noReason': 'Ingen grunn oppgitt',
  'admin.users.timeRemaining': 'Gjenværende tid',
  'admin.users.daysUntilDeactivation': 'dager til deaktivering',
  'admin.table.user': 'Bruker',
  'admin.table.plan': 'Plan',
  'admin.table.subStatus': 'Abonnementsstatus',
  'admin.table.cancellation': 'Kansellering',
  'admin.table.payment': 'Betalingsmåte',
  'admin.table.spending': 'Forbruk',
  'admin.table.actions': 'Handlinger',
  'admin.actions.viewDetails': 'Vis detaljer',
  'admin.actions.manageSubscription': 'Administrer abonnement',
  'admin.actions.grantFree': 'Gi gratis tilgang',
  'admin.actions.block': 'Blokker bruker',
  'admin.actions.unblock': 'Opphev blokkering av bruker',
  'admin.actions.cancel': 'Avbryt',
  'admin.actions.save': 'Lagre',
  'admin.actions.delete': 'Slett',
  'admin.actions.confirm': 'Bekreft',
  'admin.actions.done': 'Ferdig',
  'admin.actions.edit': 'Rediger',
  'admin.actions.close': 'Lukk',
  'admin.table.status': 'Status',
  'admin.filter.all': 'Alle',
  'admin.subscription.active': 'Aktiv',
  'admin.subscription.cancelled': 'Kansellert',
  'admin.subscription.paused': 'Satt på pause',
  'admin.subscription.unknown': 'Ukjent',
  'admin.status.active': 'Aktiv',
  'admin.status.inactive': 'Inaktiv',
  'admin.status.pending': 'Venter',
  'admin.status.approved': 'Godkjent',
  'admin.status.rejected': 'Avvist',
  'admin.coupons.title': 'Administrasjon av rabattkoder',
  'admin.coupons.subtitle': 'Opprett og administrer rabattkoder',
  'admin.coupons.newCoupon': 'Ny rabattkode',
  'admin.coupons.registrationCoupons': 'Registreringskuponger',
  'admin.coupons.trialCoupons': 'Prøvetilgangskuponger',
  'admin.coupons.type': 'Type',
  'admin.coupons.plan': 'Plan',
  'admin.coupons.value': 'Verdi',
  'admin.coupons.usage': 'Bruk',
  'admin.coupons.validUntil': 'Gyldig til',
  'admin.coupons.created': 'Opprettet',
  'admin.coupons.actions': 'Handlinger',
  'admin.coupons.copyCode': 'Kopier kode',
  'admin.coupons.allPlans': 'Alle planer',
  'admin.coupons.discount': 'Rabatt',
  'admin.coupons.days': 'dager',
  'admin.coupons.months': 'måneder',
  'admin.coupons.free': 'gratis',
  'admin.coupons.unlimited': 'Ubegrenset',
  'admin.coupons.createRegistration': 'Opprett registreringskupong',
  'admin.coupons.createTrial': 'Opprett prøvetilgangskupong',
  'admin.coupons.couponCode': 'Rabattkode',
  'admin.coupons.codePlaceholder': 'f.eks. NF-7X3K9M',
  'admin.coupons.generateCode': 'Generer ny kode',
  'admin.coupons.alertFillRequired': 'Vennligst fyll ut alle påkrevde felt',
  'admin.coupons.alertSelectExpiry': 'Vennligst velg en utløpsdato eller aktiver "Ubegrenset gyldighet"',
  'admin.coupons.alertCreateError': 'Feil ved opprettelse av kupong',
  'admin.coupons.confirmDelete': 'Er du sikker på at du vil slette denne kupongen?',
  'admin.coupons.discountPercent': 'Rabatt (%)',
  'admin.coupons.bonusCredits': 'Bonusstudiepoeng',
  'admin.coupons.freeDuration': 'Gratis varighet',
  'admin.coupons.maxUses': 'Maks bruk',
  'admin.coupons.expiryDate': 'Utløpsdato',
  'admin.coupons.unlimitedValidity': 'Ubegrenset gyldighet',
  'admin.coupons.unlimitedUses': 'Ubegrenset bruk',
  'admin.coupons.trialCredits': 'Prøvestudiepoeng',
  'admin.coupons.trialDuration': 'Prøvevarighet',
  'admin.coupons.typePlaceholder': 'f.eks. Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Varighet',
  'admin.stats.totalUsers': 'Totalt brukere',
  'admin.stats.monthlyRevenue': 'Månedlig inntekt',
  'admin.stats.activeSubscriptions': 'Aktive abonnementer',
  'admin.stats.average': 'Gjennomsnitt',
  'admin.stats.revenuePerUser': 'Inntekt per bruker',
  'admin.stats.grossRevenue': 'Bruttoinntekt',
  'admin.stats.net': 'NETTO',
  'admin.stats.netRevenue': 'Nettoinntekt',
  'admin.stats.churnRate': 'Avgangsrate',
  'admin.stats.planDistribution': 'Planfordeling',
  'admin.stats.users': 'brukere',
  'admin.stats.revenueByPlan': 'Inntekt etter plan',
  'admin.stats.recentActivity': 'Siste aktivitet',
  'admin.stats.activity1': 'Thomas Weber oppgraderte til Builder',
  'admin.stats.activity2': 'Ny bruker registrerte seg',
  'admin.stats.activity3': 'Anna Schmidt oppgraderte til Pro',
  'admin.stats.hoursAgo2': '2 timer siden',
  'admin.stats.hoursAgo5': '5 timer siden',
  'admin.stats.dayAgo1': '1 dag siden',
  'admin.stats.couponStats': 'Kupongstatistikk',
  'admin.stats.totalRedemptions': 'Totalt innløst',
  'admin.stats.activeCoupons': 'Aktive kuponger',
  'admin.stats.registrationRedemptions': 'Registreringsinnløsninger',
  'admin.stats.trialRedemptions': 'Prøveinnløsninger',
  'admin.stats.couponDistribution': 'Kupongfordeling',
  'admin.stats.registrationCoupons': 'Registreringskuponger',
  'admin.stats.trialCoupons': 'Prøvekuponger',
  'admin.stats.expiredInactive': 'Utløpt/inaktiv',
  'admin.stats.topCoupons': 'Mest brukte kuponger',
  'admin.stats.redemptions': 'innløsninger',
  'admin.stats.noCouponsRedeemed': 'Ingen kuponger innløst ennå',
  'admin.downgrade.pending': 'venter',
  'admin.downgrade.refunds': 'Refusjoner',
  'admin.downgrade.sectionRequests': 'Forespørsler',
  'admin.downgrade.sectionStats': 'Statistikk',
  'admin.downgrade.sectionRules': 'Regler',
  'admin.downgrade.pendingRequests': 'Ventende forespørsler',
  'admin.downgrade.approvedRequests': 'Godkjente forespørsler',
  'admin.downgrade.rejectedRequests': 'Avviste forespørsler',
  'admin.downgrade.activeRules': 'Aktive regler',
  'admin.downgrade.autoRules': 'Automatiske nedgraderingsregler',
  'admin.downgrade.autoRulesDesc': 'Opprett regler som automatisk utløser nedgraderinger basert på bruksatferd',
  'admin.downgrade.newRule': 'Ny regel',
  'admin.downgrade.totalRules': 'Totalt regler',
  'admin.downgrade.triggeredActions': 'Utløste handlinger',
  'admin.downgrade.conditionsAnd': 'Betingelser (AND-koblet)',
  'admin.downgrade.action': 'Handling',
  'admin.downgrade.successTitle': 'Nedgradering vellykket!',
  'admin.downgrade.successDesc': 'Brukeren er vellykket nedgradert og refusjonen er behandlet.',
  'admin.downgrade.closing': 'Lukker...',
  'admin.downgrade.title': 'Nedgrader bruker',
  'admin.downgrade.currentPlan': 'Nåværende plan',
  'admin.downgrade.spending': 'Forbruk',
  'admin.downgrade.availablePlans': 'Tilgjengelige planer for nedgradering',
  'admin.downgrade.perMonth': 'per måned',
  'admin.downgrade.refundCalc': 'Refusjonsberegning',
  'admin.downgrade.currentPlanLabel': 'Nåværende plan',
  'admin.downgrade.newPlan': 'Ny plan',
  'admin.downgrade.remainingDays': 'Gjenværende dager',
  'admin.downgrade.daysOf': '15 av 30 dager',
  'admin.downgrade.proRataRefund': 'Forholdsmessig refusjon',
  'admin.downgrade.importantNote': 'Viktig merknad',
  'admin.downgrade.warningDesc': 'Nedgraderingen utføres umiddelbart. Brukeren mister tilgang til premiumfunksjoner og overskytende studiepoeng fjernes.',
  'admin.downgrade.processing': 'Behandler...',
  'admin.downgrade.execute': 'Utfør nedgradering',
  'admin.downgrade.notification': 'Varsel',
  'admin.downgrade.noNotification': 'Ingen varsling',
  'admin.downgrade.daysPeriod': 'dagers overgangsperiode',
  'admin.downgrade.created': 'Opprettet:',
  'admin.downgrade.triggered': 'utløst',
  'admin.downgrade.noRules': 'Ingen regler opprettet ennå',
  'admin.downgrade.createFirstRule': 'Opprett første regel',
  'admin.downgrade.editRule': 'Rediger regel',
  'admin.downgrade.createRule': 'Opprett ny regel',
  'admin.downgrade.ruleName': 'Regelnavn',
  'admin.downgrade.description': 'Beskrivelse',
  'admin.downgrade.allConditions': 'Betingelser (alle må være oppfylt)',
  'admin.downgrade.addCondition': 'Legg til betingelse',
  'admin.downgrade.type': 'Type',
  'admin.downgrade.value': 'Verdi',
  'admin.downgrade.fromPlan': 'Fra plan',
  'admin.downgrade.toPlan': 'Til plan',
  'admin.condition.inactivity': 'Inaktivitet',
  'admin.condition.creditUsage': 'Studiepoengbruk',
  'admin.condition.loginFrequency': 'Innloggingsfrekvens',
  'admin.condition.featureUsage': 'Funksjonsbruk',
  'admin.condition.supportTickets': 'Støttehenvendelser',
  'admin.operator.lessThan': 'mindre enn',
  'admin.operator.greaterThan': 'mer enn',
  'admin.operator.equals': 'nøyaktig',
  'admin.operator.between': 'mellom',
  'admin.unit.days': 'dager',
  'admin.unit.perMonth': 'per måned',
  'admin.unit.count': 'antall',
  'admin.transactions.all': 'Alle transaksjoner',
  'admin.transactions.allCards': 'Alle kort',
  'admin.transactions.notFound': 'Ingen transaksjoner funnet',
  'admin.transactions.totalLabel': 'Totalt',
  'admin.transactions.transactions': 'transaksjoner',
  'admin.tips.title': 'Dagens tips',
  'admin.tips.subtitle': 'Opprett og administrer tips som vises for alle brukere',
  'admin.tips.active': 'Aktiv',
  'admin.tips.currentlyShown': 'Dette tipset vises for alle brukere',
  'admin.tips.createNew': 'Opprett nytt tips',
  'admin.tips.generating': 'Genererer...',
  'admin.tips.generateAI': 'Generer AI-tips',
  'admin.tips.titleLabel': 'Tittel',
  'admin.tips.titlePlaceholder': 'f.eks. Dagens tips',
  'admin.tips.category': 'Kategori',
  'admin.tips.categoryTip': 'Tips',
  'admin.tips.categoryFeature': 'Ny funksjon',
  'admin.tips.categoryProductivity': 'Produktivitet',
  'admin.tips.categoryUpdate': 'Oppdatering',
  'admin.tips.content': 'Innhold',
  'admin.tips.contentPlaceholder': 'Skriv tipset ditt for brukere her...',
  'admin.tips.addTip': 'Legg til tips',
  'admin.tips.allTips': 'Alle tips',
  'admin.tips.noTips': 'Ingen tips opprettet ennå',
  'admin.tips.noTipsHint': 'Klikk "Generer AI-tips" for å komme i gang',
  'admin.noData': 'Ingen data tilgjengelig',
  'admin.range.7d': '7 dager',
  'admin.range.30d': '30 dager',
  'admin.range.90d': '90 dager',
  'admin.range.1y': '1 år',
  'admin.actions.saveSettings': 'Lagre innstillinger',
  'admin.actions.create': 'Opprett',
  'admin.downgrade.sectionReports': 'Rapporter',
  'admin.downgrade.settings': 'Nedgraderingsinnstillinger',
  'admin.downgrade.autoApprove': 'Automatisk godkjenning',
  'admin.downgrade.autoApproveDesc': 'Godkjenn nedgraderingsforespørsler automatisk',
  'admin.downgrade.refundPolicy': 'Refusjonspolicy',
  'admin.downgrade.prorata': 'Forholdsmessig refusjon',
  'admin.downgrade.prorataDesc': 'Forholdsmessig refusjon basert på gjenværende dager',
  'admin.downgrade.fullRefund': 'Full refusjon',
  'admin.downgrade.fullRefundDesc': 'Full refusjon av prisforskjellen',
  'admin.downgrade.noRefund': 'Ingen refusjon',
  'admin.downgrade.noRefundDesc': 'Nedgradering uten refusjon',
  'admin.downgrade.daysRemaining15': '(med 15 dager igjen)',
  'admin.downgrade.requestsTitle': 'Nedgraderingsforespørsler',
  'admin.downgrade.approvalRate': 'Godkjenningsrate',
  'admin.downgrade.mostCommonTransition': 'Vanligste overgang',
  'admin.downgrade.mostCommonReason': 'Vanligste grunn',
  'admin.downgrade.avgProcessingTime': 'Gjennomsnittlig behandlingstid',
  'admin.downgrade.avgTimeDesc': 'Gjennomsnittlig tid til beslutning',
  'admin.downgrade.totalRefunds': 'Totalt refusjoner',
  'admin.downgrade.pendingRefunds': 'Ventende refusjoner',
  'admin.downgrade.summary': 'Sammendrag',
  'admin.downgrade.total': 'Totalt',
  'admin.downgrade.csvDesc': 'For Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Last ned som CSV',
  'admin.downgrade.jsonDesc': 'For utviklere, API-er',
  'admin.downgrade.downloadJSON': 'Last ned som JSON',
  'admin.downgrade.exportInfo': 'Eksporten inneholder',
  'admin.downgrade.entries': 'oppføringer fra den valgte perioden',
  'admin.downgrade.topReasons': 'Vanligste nedgraderingsgrunner',
  'admin.downgrade.refundHistory': 'Refusjonshistorikk',
  'admin.downgrade.noRefunds': 'Ingen refusjoner ennå',
  'admin.downgrade.statistics': 'Nedgraderingsstatistikk',
  'admin.downgrade.requests': 'Forespørsler',
  'admin.downgrade.monthlyTrend': 'Månedlig trend',
  'admin.downgrade.planTransitions': 'Planoverganger',
  'admin.downgrade.trend': 'Trend (vs. forrige måned)',
  'admin.downgrade.trendDesc': 'Færre nedgraderinger = bedre',
  'admin.coupons.allPlansUniversal': 'Alle planer (universell)',
  'admin.coupons.onlyStarter': 'Kun Starter',
  'admin.coupons.onlyPro': 'Kun Pro',
  'admin.coupons.onlyBuilder': 'Kun Builder',
  'admin.coupons.allPlansHint': 'Velg "Alle planer" for en universell kupong',
  'admin.coupons.discountOptional': 'Rabatt % (valgfritt)',
  'admin.coupons.discountPlaceholder': 'f.eks. 50 for 50 % rabatt',
  'admin.coupons.bonusCreditsOptional': 'Bonusstudiepoeng (valgfritt)',
  'admin.coupons.bonusCreditsPlaceholder': 'f.eks. 500',
  'admin.coupons.freeDurationOptional': 'Gratis varighet (valgfritt)',
  'admin.coupons.durationPlaceholder': 'f.eks. 30',
  'admin.coupons.freeDurationHint': 'f.eks. 30 dager gratis bruk',
  'admin.coupons.noLimit': 'Ingen bruksbegrensning',
  'admin.coupons.noExpiry': 'Ingen utløpsdato',
  'admin.coupons.creditsPlaceholder': 'f.eks. 100',
  'admin.coupons.creditsHint': 'Antall studiepoeng for prøvetilgangen',
  'admin.coupons.trialDurationHint': 'Hvor lenge prøvetilgangen er gyldig',
  'admin.coupons.autoCalculated': 'Beregnes automatisk fra prøvevarighet',
  'admin.websiteEditor.title': 'Nettstedredigering',
  'admin.websiteEditor.subtitle': 'Rediger alle seksjoner på hjemmesiden',
  'admin.websiteEditor.openPreview': 'Åpne forhåndsvisning',
  'admin.websiteEditor.group.structure': 'Sidestruktur',
  'admin.websiteEditor.group.design': 'Design og utforming',
  'admin.websiteEditor.group.settings': 'Innstillinger',
  'admin.websiteEditor.tab.navbar': 'Navigasjon',
  'admin.websiteEditor.tab.howitworks': 'Slik fungerer det',
  'admin.websiteEditor.tab.about': 'Om oss',
  'admin.websiteEditor.tab.pricing': 'Priser',
  'admin.websiteEditor.tab.sections': 'Seksjoner',
  'admin.websiteEditor.tab.media': 'Media',
  'admin.websiteEditor.tab.chatwidget': 'Snakk med oss',
  'admin.websiteEditor.tab.invoice': 'Fakturaer',
  'admin.websiteEditor.tab.legal': 'Juridisk',
  'admin.websiteEditor.tab.seo': 'SEO grunnleggende',
  'admin.websiteEditor.tab.advancedseo': 'SEO avansert',
  'admin.websiteEditor.tab.versions': 'Versjoner',
  'admin.hero.title': 'Rediger helteseksjon',
  'admin.hero.subtitle': 'Tekster, knapper og statistikk på hjemmesiden',
  'admin.hero.reset': 'Tilbakestill',
  'admin.hero.save': 'Lagre',
  'admin.hero.savedMsg': 'Helteinnhold lagret!',
  'admin.hero.badge': 'Merketekst',
  'admin.hero.headings': 'Overskrifter',
  'admin.hero.line1White': 'Linje 1 (hvit)',
  'admin.hero.line2Gold': 'Linje 2 (gull)',
  'admin.hero.subtitleSection': 'Undertekst',
  'admin.hero.line1': 'Linje 1',
  'admin.hero.line2': 'Linje 2',
  'admin.hero.buttons': 'Knapper',
  'admin.hero.primaryBtn': 'Primærknapp (gull)',
  'admin.hero.secondaryBtn': 'Sekundærknapp (kant)',
  'admin.hero.stats': 'Statistikk',
  'admin.hero.statN': 'Statistikk {{n}}',
  'admin.hero.value': 'Verdi',
  'admin.hero.label': 'Etikett',
  'admin.hero.previewNote': 'Endringer vil være synlige på hjemmesiden etter lagring. Last siden på nytt for å se forhåndsvisningen.',

  // Idea History
  'history.title': 'Idéhistorikk',
  'history.countLabel': '{{count}} analyser',
  'history.recentLabel': 'Dine siste analyser',
  'history.exportAll': 'Eksporter alle',
  'history.metrics.marketSize': 'Markedsstørrelse',
  'history.metrics.competition': 'Konkurranse',
  'history.metrics.startingCapital': 'Startkapital',
  'history.metrics.timeToMarket': 'Tid til marked',
  'history.metrics.profitPotential': 'Fortjenestepotensial',
  'history.metrics.scalability': 'Skalerbarhet',
  'history.summary.title': 'Sammendrag',
  'history.download': 'Last ned',
  'history.downloadJSON': 'Lagre som JSON',
  'history.downloadTXT': 'Lagre som TXT',
  'history.downloadPDF': 'Lagre som PDF',
  'history.fullAnalysis': 'Full analyse',
  'history.searchPlaceholder': 'Søk etter tittel eller tagger...',
  'history.filterAll': 'Alle vurderinger',
  'history.loading': 'Laster analyser...',
  'history.noResults': 'Ingen resultater funnet',
  'history.empty': 'Ingen analyser ennå',
  'history.emptyHint': 'Start en analyse i AI-assistenten',
  'history.delete': 'Slett',
  'history.cancel': 'Avbryt',
  'history.deleteModalTitle': 'Slett analyse?',
  'history.deleteModalDesc': '"{{title}}" vil bli slettet permanent.',
  'history.errorLoading': 'Feil ved lasting av analyser',
  'history.deleteSuccess': 'Analyse slettet',
  'history.deleteError': 'Feil ved sletting av analyse',
  'history.jsonExported': 'JSON eksportert',
  'history.txtExported': 'TXT eksportert',
  'history.allExported': '{{count}} idéer eksportert',
  'history.analysisHeader': 'IDÉANALYSE',
  'history.titleLabel': 'Tittel',
  'history.ratingLabel': 'Vurdering',
  'history.dateLabel': 'Dato',
  'history.creditsLabel': 'Studiepoeng',
  'history.analysisSection': 'Analyse',

  // Overview
  'overview.title': 'Oversikt',
  'overview.last24h': 'Siste 24 timer',
  'overview.analysesToday': 'Analyser i dag',
  'overview.totalAnalyses': 'Totalt analyser',
  'overview.successRate': 'Suksessrate',
  'overview.topRatings': 'Toppvurderinger',
  'overview.recentActivity': 'Siste aktivitet',
  'overview.viewAll': 'Vis alle',
  'overview.quickAccess': 'Hurtigtilgang',
  'overview.quick.newAnalysis': 'Start ny analyse',
  'overview.quick.newAnalysisDesc': 'Start en ny AI-drevet nisjeanalyse',
  'overview.quick.myAnalyses': 'Mine analyser',
  'overview.quick.myAnalysesDesc': 'Vis alle tidligere analyser',
  'overview.quick.buyCredits': 'Kjøp studiepoeng',
  'overview.quick.buyCreditsDesc': 'Flere studiepoeng for flere analyser',
  'overview.quick.settings': 'Innstillinger',
  'overview.quick.settingsDesc': 'Tilpass profil og preferanser',
  'overview.unlimitedCredits': 'Ubegrensede studiepoeng tilgjengelig',
  'overview.creditsAvailable': 'studiepoeng tilgjengelig',
  'overview.upgradePlan': 'Oppgrader plan',
  'overview.buyCredits': 'Kjøp studiepoeng',
  'overview.creditUsage': 'Studiepoengbruk denne måneden',
  'overview.available': 'tilgjengelig',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Oppgraderinger',
  'admin.transactions.downgrades': 'Nedgraderinger',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} har nå {{months}} måned(er) med gratis {{plan}}-plan',
  'admin.users.blockSuccess': '{{name}} ble blokkert',
  'admin.users.unblockSuccess': 'Blokkeringen av {{name}} ble opphevet',
  'admin.users.removeFreeSuccess': 'Gratisstatusen til {{name}} ble fjernet',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Gratis',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Oppdag ny funksjon',
  'admin.tips.productivityBoost': 'Produktivitetsboost',
  'admin.tips.importantUpdate': 'Viktig oppdatering',
  'admin.tips.tipOfDay': 'Dagens tips',

  'admin.actions.activate': 'Aktiver',
  'admin.actions.deactivate': 'Deaktiver',
  'admin.websiteEditor.tab.features': 'Funksjoner',
  'admin.websiteEditor.tab.testimonials': 'Attester',
  'admin.websiteEditor.tab.faq': 'Ofte stilte spørsmål',
  'admin.websiteEditor.tab.cta': 'Handlingspåkalling',
  'admin.websiteEditor.tab.footer': 'Bunntekst',
  'admin.websiteEditor.tab.design': 'Design',
  'admin.websiteEditor.tab.customcode': 'Egendefinert kode',
  'admin.websiteEditor.tab.socials': 'Sosiale medier',
  'admin.websiteEditor.tab.importexport': 'Import/eksport',

  // --- AI Settings Editor ---
  'admin.ai.title': 'Innstillinger for AI-assistent',
  'admin.ai.subtitle': 'Konfigurer atferd, stil og analysedybde',
  'admin.ai.smartWeightingActive': 'Smart vekting aktiv',
  'admin.ai.smartWeightingDesc': 'AI-en kombinerer automatisk alle perspektiver med smart vekting. Med flere forhåndsinnstillinger blir den første vektet høyere (primær forhåndsinnstilling). Du kan også justere vektingen manuelt.',
  'admin.ai.modelTitle': 'IdeaVerdict AI-modell',
  'admin.ai.modelSubtitle': 'Velg AI-motoren for alle brukeranalyser',
  'admin.ai.activeModel': 'Aktiv modell:',
  'admin.ai.activeModelDesc': 'Alle brukere mottar svar fra denne modellen.',
  'admin.ai.recommendations': 'Anbefalinger for optimale resultater',
  'admin.ai.new': 'NY',
  'admin.ai.recommendationsDesc': 'Testede forhåndsinnstillingskombinasjoner for best analysekvalitet',
  'admin.ai.recommendationsInfo': 'Disse kombinasjonene er testet og gir de beste resultatene. Klikk på en anbefaling for å bruke den direkte.',
  'admin.ai.active': 'AKTIV',
  'admin.ai.apply': 'Bruk',
  'admin.ai.avoid': 'Unngå',
  'admin.ai.excellentQuality': 'Utmerket kvalitet',
  'admin.ai.goodQuality': 'God kvalitet',
  'admin.ai.poorQuality': 'Fortynnet kvalitet - ikke anbefalt',
  'admin.ai.proTips': 'Profftips',
  'admin.ai.tip1Title': '2 forhåndsinnstillinger er optimalt:',
  'admin.ai.tip1Desc': 'Tydelig perspektiv uten fortynning',
  'admin.ai.tip2Title': 'Primær forhåndsinnstilling har betydning:',
  'admin.ai.tip2Desc': 'Den første forhåndsinnstillingen har størst innflytelse',
  'admin.ai.tip3Title': 'Unngå motsetninger:',
  'admin.ai.tip3Desc': '"EXTREME" + Creative = motstridende',
  'admin.ai.tip4Title': 'Maksimalt 3 forhåndsinnstillinger:',
  'admin.ai.tip4Desc': 'Med 4+ forhåndsinnstillinger blir resultatet for generelt',
  'admin.ai.warningManyPresets': 'Advarsel: Mange forhåndsinnstillinger',
  'admin.ai.warningManyPresetsDesc': 'Du har valgt {{count}} forhåndsinnstillinger. Dette kan fortynne resultatet.',
  'admin.ai.warningRecommend': 'Anbefalt: Maksimalt 2-3 forhåndsinnstillinger',
  'admin.ai.forOptimalResults': 'for optimale resultater.',
  'admin.ai.presets': 'Forhåndsinnstillinger',
  'admin.ai.multiSelect': '(flere valg mulig)',
  'admin.ai.presetsDesc': 'Velg en eller flere forhåndsinnstillinger. Den første forhåndsinnstillingen er primær forhåndsinnstilling med høyest vekting.',
  'admin.ai.primaryPreset': 'Primær forhåndsinnstilling',
  'admin.ai.weightControl': 'Vektkontroll',
  'admin.ai.weightControlDesc': 'Juster hvor sterkt hver forhåndsinnstilling påvirker analysen',
  'admin.ai.manual': 'Manuell',
  'admin.ai.automatic': 'Automatisk',
  'admin.ai.autoWeightingActive': 'Automatisk vekting aktiv:',
  'admin.ai.autoWeightingDesc': 'Vektingen optimaliseres automatisk basert på antall forhåndsinnstillinger.',
  'admin.ai.primary': 'PRIMÆR',
  'admin.ai.totalWeight': 'Totalt',
  'admin.ai.shouldBe100': 'bør være 100 %',
  'admin.ai.normalize': 'Normaliser',
  'admin.ai.combinedSettings': 'Kombinerte innstillinger',
  'admin.ai.presetsCount': 'forhåndsinnstillinger',
  'admin.ai.strictness': 'Strenghet',
  'admin.ai.realism': 'Realisme',
  'admin.ai.creativity': 'Kreativitet',
  'admin.ai.detailLevel': 'Detaljnivå',
  'admin.ai.customInstructions': 'Egendefinerte instruksjoner',
  'admin.ai.customInstructionsDesc': 'Ytterligere instruksjoner som kombineres med forhåndsinnstillingene',
  'admin.ai.customInstructionsPlaceholder': 'f.eks. "Fokuser på det nordiske markedet", "Bruk alltid konkrete tall", "Sammenlign med eksisterende konkurrenter", "Svar alltid med eksempler"...',
  'admin.ai.customInstructionsHint': 'Disse instruksjonene kombineres automatisk med de valgte forhåndsinnstillingene.',
  'admin.ai.manualFinetuning': 'Manuell finjustering',
  'admin.ai.manualFinetuningHint': '(valgfritt, overstyrer forhåndsinnstillingsverdier)',
  'admin.ai.manualFinetuningDesc': 'Juster de kombinerte verdiene manuelt hvis du vil finjustere noe.',
  'admin.ai.tone': 'Tone',
  'admin.ai.mild': 'Mild',
  'admin.ai.strict': 'Streng',
  'admin.ai.creative': 'Kreativ',
  'admin.ai.realistic': 'Realistisk',
  'admin.ai.conservative': 'Konservativ',
  'admin.ai.compact': 'Kompakt',
  'admin.ai.detailed': 'Detaljert',
  'admin.ai.responseLength': 'Svar Lengde',
  'admin.ai.short': 'Kort og konsist',
  'admin.ai.medium': 'Middels',
  'admin.ai.long': 'Detaljert',
  'admin.ai.focusAreas': 'Analysefokusområder',
  'admin.ai.autoRating': 'Automatisk vurdering',
  'admin.ai.autoRatingDesc': 'Hver analyse mottar automatisk en vurdering (Bra/Middels/Dårlig)',
  'admin.ai.showSources': 'Vis kilder',
  'admin.ai.showSourcesDesc': 'Referanser til datakilder og markedsdata i svar',
  'admin.ai.hidePreview': 'Skjul forhåndsvisning',
  'admin.ai.showPreview': 'Vis forhåndsvisning',
  'admin.ai.aiBehavior': 'AI-atferd',
  'admin.ai.length': 'Lengde',
  'admin.ai.liveExample': 'Live eksempel',
  'admin.ai.testSettings': 'Test innstillingene dine',
  'admin.ai.selectExampleQuestion': 'Velg eksempelspørsmål:',
  'admin.ai.userAsks': 'Bruker spør:',
  'admin.ai.generating': 'AI genererer svar...',
  'admin.ai.generateExample': 'Generer eksempelsvar',
  'admin.ai.aiResponds': 'AI-assistenten svarer:',
  'admin.ai.generateHint': 'Klikk "Generer eksempelsvar" for å se hvordan AI-en svarer med innstillingene dine.',
  'admin.ai.reset': 'Tilbakestill',
  'admin.ai.saved': 'Lagret!',
  'admin.ai.saveSettings': 'Lagre innstillinger',

  // --- Table headers ---
  'admin.coupons.code': 'Kode',
  'admin.coupons.credits': 'Studiepoeng',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Balansert analyse med høy kvalitet. Det beste valget for de fleste nisjevurderinger og idévalideringer.',
  'admin.ai.model.preciseAnalyses': 'Presise analyser',
  'admin.ai.model.bestBalance': 'Best balanse',
  'admin.ai.model.recommended': 'Anbefalt',
  'admin.ai.model.fastDesc': 'Lynraske svar for raske nisjesjekker, idédugnad og innledende vurderinger. Ideelt når hastighet betyr noe.',
  'admin.ai.model.fast': 'HURTIG',
  'admin.ai.model.fastestResponses': 'Raskeste svar',
  'admin.ai.model.thinkingDesc': 'Dyp analyse med avansert logisk tenkning. For komplekse markedsanalyser, kritiske vurderinger og strategisk planlegging.',
  'admin.ai.model.deepestAnalysis': 'Dypeste analyse',
  'admin.ai.model.logicalThinking': 'Logisk tenkning',
  'admin.ai.model.strategy': 'Strategi',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Streng analyse',
  'admin.ai.preset.strict.desc': 'Kritisk, faktabasert, ingen sukkerbelegg. Avslører svakheter nådeløst.',
  'admin.ai.preset.extreme.name': 'EKSTREM analyse',
  'admin.ai.preset.extreme.desc': 'Maksimal strenghet, nådeløs kritikk, fokus på verst tenkelige scenario. Bare for tøffe virkelighetssjekker.',
  'admin.ai.preset.professional.name': 'Profesjonell',
  'admin.ai.preset.professional.desc': 'Objektiv, strukturert, balansert. Som en erfaren forretningskonsulent.',
  'admin.ai.preset.realistic.name': 'Realistisk',
  'admin.ai.preset.realistic.desc': 'Ærlig og praktisk. Fokus på gjennomførbar implementering og reelle markedsdata.',
  'admin.ai.preset.creative.name': 'Kreativ og motiverende',
  'admin.ai.preset.creative.desc': 'Inspirerende, idérik, positiv. Finner muligheter og utradisjonelle veier.',
  'admin.ai.preset.balanced.name': 'Balansert',
  'admin.ai.preset.balanced.desc': 'God blanding av kritikk og motivasjon. Standardmodus.',
  'admin.ai.preset.investor.name': 'Investorperspektiv',
  'admin.ai.preset.investor.desc': 'Som en venturekapitalist. Fokus på skalering, avkastning og exit-strategi.',
  'admin.ai.preset.startup-coach.name': 'Startup-coach',
  'admin.ai.preset.startup-coach.desc': 'Praktisk mentor for gründere. Fokus på rask implementering og MVP.',
  'admin.ai.preset.market-researcher.name': 'Markedsforsker',
  'admin.ai.preset.market-researcher.desc': 'Datadrevet og analytisk. Dyp markeds- og konkurranseanalyse.',
  'admin.ai.preset.risk-analyst.name': 'Risikoanalytiker',
  'admin.ai.preset.risk-analyst.desc': 'Fokus på risikoer og verst tenkelige scenarioer. For realistisk planlegging.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Markedsanalyse',
  'admin.ai.focus.wettbewerb': 'Konkurranse',
  'admin.ai.focus.monetarisierung': 'Monetisering',
  'admin.ai.focus.risiken': 'Risikoer',
  'admin.ai.focus.finanzen': 'Finans',
  'admin.ai.focus.skalierung': 'Skalering',
  'admin.ai.focus.innovation': 'Innovasjon',
  'admin.ai.focus.trends': 'Trender',
  'admin.ai.focus.differenzierung': 'Differensiering',
  'admin.ai.focus.umsetzung': 'Implementering',
  'admin.ai.focus.zielgruppe': 'Målgruppe',
  'admin.ai.focus.marketing': 'Markedsføring',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Direkte og skarp',
  'admin.ai.tone.professionell': 'Profesjonell og objektiv',
  'admin.ai.tone.ehrlich': 'Ærlig og praktisk',
  'admin.ai.tone.motivierend': 'Motiverende og positiv',
  'admin.ai.tone.freundlich': 'Vennlig og støttende',
  'admin.ai.tone.akademisch': 'Akademisk og analytisk',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Hvilken lønnsom nisje anbefaler du?',
  'admin.ai.question.evaluate': 'Vurder idéen min: En app for hundeeiere',
  'admin.ai.question.trends': 'Hvilke trender har potensial for tiden?',
  'admin.ai.question.sharpen': 'Hvordan kan jeg skjerpe nisjen min?',

  'admin.ai.rec.bestCombination.title': '🏆 Beste kombinasjon (2 forhåndsinnstillinger)',
  'admin.ai.rec.bestCombination.desc': 'Kritisk, men konstruktiv, med konkrete handlingssteg',
  'admin.ai.rec.bestCombination.useCase': 'Anbefalt for de fleste analyser',

  'admin.ai.rec.balancedThree.title': '⚖️ Balansert (3 forhåndsinnstillinger)',
  'admin.ai.rec.balancedThree.desc': 'Profesjonell, realistisk og investorvennlig',
  'admin.ai.rec.balancedThree.useCase': 'For omfattende forretningsanalyser',

  'admin.ai.rec.creativeDriven.title': '💡 Kreativ og motiverende (2 forhåndsinnstillinger)',
  'admin.ai.rec.creativeDriven.desc': 'Inspirerende med praktiske implementeringstips',
  'admin.ai.rec.creativeDriven.useCase': 'For idédugnad og idémyldring',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Åpne meny',
  'header.home': 'Hjem',
  'header.notifications': 'Varsler',
  'header.settings': 'Innstillinger',
  'header.profile': 'Profil',
  'sidebar.collapse': 'Skjul sidemeny',
  'sidebar.expand': 'Vis sidemeny',
  'sidebar.close': 'Lukk meny',
  'sidebar.plan': 'Plan',
  'sidebar.backToWebsite': 'Tilbake til nettstedet',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Velkommen tilbake',
  'overview.greetingSub': 'Dette skjer på dommerpulten din.',
  'overview.heroCta': 'Ny dom',
  'overview.currentPlan': 'Nåværende plan',
  'overview.creditsLabel': 'kreditter',
  'overview.usedThisCycle': 'Brukt denne syklusen',
  'overview.resetsOn': 'Tilbakestilles',
  'overview.unlimitedTitle': 'Ubegrenset',
  'overview.builderPerk': 'Du har full Builder-tilgang — ingen grenser.',
  'overview.runOne': 'Kjør en dom',
  'overview.lastVerdicts': 'Dine siste 5 dommer',
  'overview.noActivity': 'Ingen dommer ennå — start første analyse',
  'overview.tipTitle': 'Tips',
  'overview.tipBody': 'Kjør en idé gjennom to språk — hvis dommen mykes opp i ett, er antagelsene dine lokale, ikke universelle.',
  'onboard.skip': "Hopp over",
  'onboard.cta.next': "Neste",
  'onboard.cta.start': "Kom i gang",
  'onboard.s1.title': "Velkommen til IdeaVerdict",
  'onboard.s1.body': "En AI-dom over forretningsideen din — før du bygger.",
  'onboard.s2.title': "Brutalt ærlige dommer",
  'onboard.s2.body': "Ingen hype, ingen smiger. Ekte markedsdata, ekte konkurrenter, ekte risiko.",
  'onboard.s3.title': "Builder-rapporter som PDF",
  'onboard.s3.body': "Generer rapporter på 25-75 sider med full arkitektur, økonomi og go-to-market-strategi.",
  'onboard.s4.title': "Klar når du er",
  'onboard.s4.body': "Registrer deg og få din første dom på under ett minutt.",
  'builderReport.title': "Bygger din Builder-rapport",
  'builderReport.subtitle': "Omfattende analyse + utviklerbriefing — lastes ned som PDF når den er klar.",
  'builderReport.idea': "Ideen din",
  'builderReport.ideaPlaceholder': "Beskriv forretningsideen din (eller la stå tom for å bruke ideen du sist diskuterte)…",
  'builderReport.cta': "Generer rapport",
  'builderReport.credits': "kreditter",
  'builderReport.deductedNow': "Trekkes ved suksess",
  'builderReport.dontClose': "Ikke lukk dette vinduet — generering kan ta 30-90 sekunder.",
  'builderReport.done': "PDF lastet ned — sjekk nedlastingsmappen.",
  'builderReport.failed': "Generering mislyktes",
  'builderReport.close': "Lukk",
  'builderReport.cancel': "Avbryt",
  'builderReport.running': "Genererer…",
  'builderReport.retry': "Prøv igjen",
  'builderReport.unknownError': "Generering mislyktes. Kredittene dine skal refunderes.",
  'builderReport.signInRequired': "Du må være innlogget for å generere en rapport.",
  'builderReport.ideaRequired': "Beskriv ideen din slik at AI-en har noe å analysere.",
  'builderReport.fromChat': "Fra din nåværende samtale",
  'builderReport.noIdeaDetected': "Bruker ideen vi har diskutert.",
  'builderReport.contextHint': "AI-en bruker alt fra denne chatten — ingen ny idé blir funnet på.",
  'builderReport.step.core': "Genererer kjerneanalyse",
  'builderReport.step.market': "Legger til utvidet markedsanalyse",
  'builderReport.step.tech': "Legger til teknisk arkitektur",
  'builderReport.step.financials': "Legger til finansielle modeller",
  'builderReport.step.compet': "Legger til konkurranseanalyse",
  'builderReport.step.gtm': "Legger til go-to-market-strategi",
  'builderReport.step.deepdive': "Legger til bransjefordypning",
  'builderReport.step.pdf': "Kompilerer PDF-en…",
  'briefing.title': "Bygger din Developer Briefing",
  'briefing.subtitle': "11-seksjoners teknisk briefing — lastes ned som PDF når den er klar.",
  'briefing.ideaPlaceholder': "Beskriv forretningsideen din (eller la stå tom for å bruke ideen du sist diskuterte)…",
  'briefing.cta': "Generer briefing",
  'briefing.step.core': "Genererer utviklerbriefing",
  'briefing.step.pdf': "Kompilerer PDF-en…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Flere kreditter + 50-siders rapporter",
  'pricing.gold.credits': "12 500 kreditter per måned",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Maks nivå + 75-siders rapporter",
  'pricing.platinum.credits': "15 000 kreditter per måned",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "no" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Bare {{count}} kreditter igjen!",
  'trial.upgradeNow': "Oppgrader nå",
  'trial.upgradeNowArrow': "Oppgrader nå →",
  'trial.creditsExhausted': "Kreditter brukt opp",
  'trial.upgradeForUnlimited': "Oppgrader for ubegrenset bruk",
  'trial.noCreditsPlaceholder': "Ingen kreditter igjen…",
  'hero.badgeHonest': "Ærlig, upartisk AI",
  'hero.badge60sec': "Dom på 60 sekunder",
  'hero.badge20Lang': "20+ språk",
  'hero.widget.label': "Idédom",
  'hero.widget.passed': "GODKJENT",
  'hero.widget.demoIdea': "AI-veileder for medisinstudenter",
  'hero.widget.market': "Marked",
  'hero.widget.demand': "Etterspørsel",
  'hero.widget.competition': "Konkurranse",
  'hero.widget.verdictReady': "Dom klar · 47 sek",
  'hero.widget.riskFlagged': "Risiko flagget",
  'hero.widget.crowdedMarket': "Trangt marked · 4 etablerte",
  'hero.widget.suggestedPivot': "Foreslått pivot",
  'hero.widget.nicheBySpecialty': "Nisje etter spesialitet",
  'hero.widget.feasibilityGain': "+38% gjennomførbarhet",
  'hero.widget.analysisDone': "Analyse ferdig",
  'hero.widget.metrics56': "5 av 6 målepunkter",
  'hero.stats.verdictSpeed': "Domshastighet",
  'cta.badge': "Dom på 60 sekunder",
  'cta.subtitleEnd': "uten gjetting.",
  'cta.signinPrompt': "Har du allerede en konto? Logg inn",
  'cta.trustTrial': "7 dagers gratis prøveperiode",
  'cta.trustNoCard': "Ingen kort nødvendig",
  'cta.trustCancel': "Avbryt når som helst",
  'footer.themeLabel': "Tema:",
  'footer.lightMode': "Lys modus",
  'footer.darkMode': "Mørk modus",
  'footer.sectionProduct': "Produkt",
  'footer.sectionLegal': "Juridisk",
  'nav.switchLight': "Bytt til lys modus",
  'nav.switchDark': "Bytt til mørk modus",
  'features.badge': "Hvorfor IdeaVerdict",
  'features.mainFeatureLabel': "Hovedpunkt",
  'chatError.planRestriction': "Denne funksjonen krever en høyere plan.",
  'chatError.creditDeduction': "Betalingsbehandlingen mislyktes. Prøv igjen.",
  'chatError.aiService': "AI-tjenesten er midlertidig utilgjengelig. Kredittene dine ble ikke belastet. Prøv igjen.",
  'chatError.parseError': "Uventet svarformat mottatt. Prøv igjen.",
  'chatError.sessionExpired': "Økten din er utløpt. Logg inn igjen.",
  'chatError.timeout': "Forespørselen tok for lang tid. Prøv igjen.",
  'chatError.generic': "Kunne ikke få svar. Prøv igjen.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "no" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Bare {{count}} kreditter igjen!",
  'trial.outOfCredits': "Kreditter brukt opp",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Trangt marked · 4 etablerte",
  'hero.widget.nicheBySpec': "Nisje etter spesialitet",
  'hero.widget.feasibilityUp': "+38% gjennomførbarhet",
  'hero.widget.fiveOfSix': "5 av 6 målepunkter",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25-siders Builder Report",
  'pricing.gold.report': "50-siders Builder Report",
  'pricing.platinum.report': "75-siders Builder Report",
  'auth.bestValue': "Beste verdi",
  'auth.elite': "Elite",
  'builderReport.friendlyError': "Vi kunne ikke fullføre rapporten din denne gangen. Kredittene dine ble ikke belastet — vennligst prøv igjen om et øyeblikk.",
  'builderReport.persistHint': "Hvis problemet vedvarer, kontakt support@ideaverdict.ai.",
};
